import Grid from '@material-ui/core/Grid';
import {
  HomePageTopVisited,
  HomePageRecentlyVisited,
} from '@backstage/plugin-home';
import { configApiRef, useApi } from '@backstage/core-plugin-api';
import { Content, ContentHeader, PageWithHeader } from '@backstage/core-components';
import {
  HomePageRequestedReviewsCard,
  HomePageYourOpenPullRequestsCard,
} from '@roadiehq/backstage-plugin-github-pull-requests';


export const HomePage = () => {
  const config = useApi(configApiRef);
  const queryForGitHubReviewRequest = config.getOptionalString('platt.home.githubPullRequests.queryForRequestedReviews');
  const queryForGitHubOpenPullRequests = config.getOptionalString('platt.home.githubPullRequests.queryForOpenPullRequests');

  return (
    <PageWithHeader title="Home" themeId="home">
      <Content>
        <ContentHeader title="" />
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <HomePageTopVisited />
          </Grid>
          <Grid item xs={12} md={6}>
            <HomePageRecentlyVisited />
          </Grid>

          {/* -- GitHub pull request related cards -- */}
          {config.getOptionalBoolean('platt.home.githubPullRequests.enabled') && (
            <>
              <Grid item md={6} xs={12}>
                <HomePageRequestedReviewsCard query={queryForGitHubReviewRequest} />
              </Grid>
              <Grid item md={6} xs={12}>
                <HomePageYourOpenPullRequestsCard query={queryForGitHubOpenPullRequests} />
              </Grid>
            </>
          )}
        </Grid>
      </Content>
    </PageWithHeader>
  );
};
